/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import {
  LuCoffee,
  LuFlower2,
  LuHeart,
  LuLeaf,
  LuPizza,
  LuSparkles,
  LuStar,
  LuUtensilsCrossed,
  LuWine,
} from "react-icons/lu";
import "./ProductTitleIconStylePicker.css";
import { PRODUCT_TITLE_ICON_STYLES } from "../../../constants/productTitleIconStyles";

const LABEL_KEYS = {
  none: "productTitleIconStyleNone",
  dots: "productTitleIconStyleDots",
  flower: "productTitleIconStyleFlower",
  food: "productTitleIconStyleFood",
  sparkles: "productTitleIconStyleSparkles",
  leaf: "productTitleIconStyleLeaf",
  star: "productTitleIconStyleStar",
  pizza: "productTitleIconStylePizza",
  coffee: "productTitleIconStyleCoffee",
  wine: "productTitleIconStyleWine",
  heart: "productTitleIconStyleHeart",
};

const PREVIEW_ACCENT = "#6366f1";

function PreviewGlyph({ style }) {
  const iconProps = { size: 18, color: PREVIEW_ACCENT, strokeWidth: 2.25 };
  if (style === "none") {
    return <span className="pt-icon-picker__none-mark">—</span>;
  }
  if (style === "dots") {
    return (
      <span className="pt-icon-picker__dots" style={{ color: PREVIEW_ACCENT }} aria-hidden>
        •
      </span>
    );
  }
  let node = null;
  switch (style) {
    case "flower":
      node = <LuFlower2 {...iconProps} />;
      break;
    case "food":
      node = <LuUtensilsCrossed {...iconProps} />;
      break;
    case "sparkles":
      node = <LuSparkles {...iconProps} />;
      break;
    case "leaf":
      node = <LuLeaf {...iconProps} />;
      break;
    case "star":
      node = <LuStar {...iconProps} />;
      break;
    case "pizza":
      node = <LuPizza {...iconProps} />;
      break;
    case "coffee":
      node = <LuCoffee {...iconProps} />;
      break;
    case "wine":
      node = <LuWine {...iconProps} />;
      break;
    case "heart":
      node = <LuHeart {...iconProps} />;
      break;
    default:
      node = null;
  }
  return node ? <span className="pt-icon-picker__preview-icon">{node}</span> : null;
}

/**
 * Visual picker for product title prefix on the customer app (per menu).
 */
export default function ProductTitleIconStylePicker({ value, onChange, idPrefix = "menu-icon" }) {
  const { t } = useTranslation();

  return (
    <div className="pt-icon-picker w-100">
      <div className="pt-icon-picker__header">
        <h3 className="pt-icon-picker__title">{t("productTitleIconStyleLabel")}</h3>
        <p className="pt-icon-picker__hint">{t("productTitleIconStyleHint")}</p>
      </div>
      <div className="pt-icon-picker__body">
        <div
          className="pt-icon-picker__grid"
          role="radiogroup"
          aria-label={t("productTitleIconStyleLabel")}
        >
          {PRODUCT_TITLE_ICON_STYLES.map((style) => {
            const selected = value === style;
            const labelKey = LABEL_KEYS[style];
            return (
              <button
                key={style}
                type="button"
                role="radio"
                aria-checked={selected}
                id={`${idPrefix}-icon-${style}`}
                className={`pt-icon-picker__card${selected ? " pt-icon-picker__card--selected" : ""}`}
                onClick={() => onChange(style)}
              >
                <div className="pt-icon-picker__preview">
                  <PreviewGlyph style={style} />
                  <span className="pt-icon-picker__preview-text">
                    {t("productTitleIconStylePreviewText")}
                  </span>
                </div>
                <div className="pt-icon-picker__name">{labelKey ? t(labelKey) : style}</div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
